import invariant from "invariant";
import { parse } from "url";


export default class Resolver {
	constructor(default_, definitions) {
		invariant(default_.indexOf('https://localhost') === -1, 'Incorrect secure localhost');
		this._default = default_;
		this._definitions = definitions;
	}

	_getPrefix(protocol, host) {
		if (protocol === null) {
			return this._default;
		}

		// Hack to unblock orgas because we use the `Link` header from the response
		// Which uses http instead of https and redirects are not allowed.

		// This will break local dev if we use a local API + local front
		if(protocol === 'http:') {
			return `https://${host}`;
		}

		if (protocol === 'api:') {
			if (!this._definitions[host]) {
				throw new Error(`Unknown api: ${host}`);
			}
			return this._definitions[host];
		}
		throw new Error(`Cannot resolve: ${protocol}//${host}`);
	}

	resolve(url) {
		const { protocol, host, path, hash } = parse(url);
		if (protocol === 'https:' && host) {
			return url;
		}
		const prefix = this._getPrefix(protocol, host);
		invariant(prefix, `prefix is empty for ${url}`);
		return `${prefix}${path || '' }${hash || ''}`;
	}

	asMiddleware() {
		// returns a function usable as a middleware of APIMiddleware
		return (fetch, store) => (url, options) => {
			return fetch(this.resolve(url), options);
		};
	}
}
